import React from 'react';

export default function RulesPage() {
  return (
    <div>
      <div className="page-head">
        <p className="eyebrow">Exhibitors</p>
        <h1>Show rules &amp; requirements</h1>
        <p>Everything you need to know before entering a dog in a Cape Rottweiler Club show.</p>
      </div>

      <div className="grid cols-2">
        <div className="card">
          <h3>Entering a dog</h3>
          <ul>
            <li>Every dog must have a valid registration number.</li>
            <li>If your dog is in our registry, its details are retrieved automatically for you to confirm.</li>
            <li>If your dog is not found, you may enter it manually and must upload a pedigree or registration document (PDF, JPG, JPEG or PNG).</li>
            <li>Manually entered dogs are marked <strong>Pending approval</strong> and only appear in the catalogue once an official approves them.</li>
          </ul>
        </div>

        <div className="card">
          <h3>Classes</h3>
          <p>
            Classes are determined from the dog's date of birth and sex, calculated against the
            show date. Age ranges are set by show officials and can differ between shows, so always
            check the classes available for the show you are entering.
          </p>
        </div>

        <div className="card">
          <h3>Grading &amp; critiques</h3>
          <p>
            Grades and judge critiques are recorded per show, so the same dog may receive different
            grades at different shows. Grades and placings are released once a class is fully judged,
            and critiques are published once reviewed.
          </p>
        </div>

        <div className="card">
          <h3>The catalogue</h3>
          <p>
            The digital catalogue is released once every entry has been approved or rejected. Until
            then the show is still visible so you can enter, but the catalogue stays hidden. Once
            released, anyone can browse and search it.
          </p>
        </div>
      </div>
    </div>
  );
}
